import script from "./checkbox_button.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkbox_button.vue?vue&type=script&setup=true&lang=ts"

import "./checkbox_button.vue?vue&type=style&index=0&id=125fc66d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125fc66d"]])

export default __exports__